import { render, staticRenderFns } from "./MStoreColumnConfiguration.vue?vue&type=template&id=32047376&"
import script from "./MStoreColumnConfiguration.vue?vue&type=script&lang=ts&"
export * from "./MStoreColumnConfiguration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports